module.exports = __webpack_public_path__ + "static/img/xianjin.8bcc7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xianjin.png
// module id = vQqk
// module chunks = 1